{
	"whiteboardSolidHeader": "confluence_frontend_solid_whiteboard_header",
	"whiteboardOptOut": "whiteboards_compliance_opt_out",
	"digitalTeammate": "cc-ai-whiteboards-enable-digital-teammate",
	"aiFirstCreation": "aifc_create_enabled"
}
